import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'forgot-id-pin-dialog',
  templateUrl: './forgot-id-pin-dialog.component.html',
  standalone: false,
})
export class ForgotIdPinDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ForgotIdPinDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: any
  ) {}

  ngOnInit(): void {}
}
